import React from 'react';

import AIReadiness from '../../images/ai.svg';

export const AIReadinessLogo = () => {
  return <img height="18" src={AIReadiness} alt="AI Readiness logo" />;
};
